// extracted by mini-css-extract-plugin
module.exports = {"root":"_3e9Vb","empty":"_30srY","sticky":"_32F_z","static":"e6UC0","onTheRight":"alJMD"};